var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAddAmountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.24 359.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "total_add_amount_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6091.57,1249.42h338.07v54.11c-36.94-14.58-72.69-12.53-106,9.39s-49.5,53.62-51.12,93.73H6127.61c-18.74,0-30.87-9.53-35.48-27.83a9.48,9.48,0,0,0-.56-1.36Zm90.61,67.37h32.88c7.6,0,12.69-4.5,12.73-11.17s-5.08-11.27-12.61-11.27H6149c-7.51,0-12.62,4.67-12.54,11.34.07,6.52,5.14,11.08,12.42,11.1C6160,1316.81,6171.09,1316.79,6182.18,1316.79Zm-.42,44.91h33.63c7.29,0,12.33-4.58,12.4-11.12s-5-11.31-12.19-11.32h-66.89c-7.19,0-12.26,4.77-12.21,11.3s5.11,11.12,12.37,11.14c10.94,0,21.94,0,32.94,0Z",
    transform: "translate(-6091.57 -1137.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6091.57,1166.33c.56-2,1-4.08,1.71-6.07,4.63-14,17.44-23.09,32.84-23.11q59.52-.06,119,0h148.56c22.16,0,36.21,14.06,36.23,36.22v8.69H6091.57Z",
    transform: "translate(-6091.57 -1137.12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6091.57,1204.53h338.07V1227H6091.57Z",
    transform: "translate(-6091.57 -1137.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6474.81,1406.72a89.82,89.82,0,1,1-89.71-89.93h.1A90,90,0,0,1,6474.81,1406.72Zm-101.15,17.87c-8.59-8.69-16.77-17.06-25.06-25.31-5-5-11.77-5.17-16.37-.68s-4.51,11.49.6,16.64q16.08,16.17,32.27,32.26c5.42,5.38,11.8,5.49,17.18.14q27.59-27.42,55-55c5-5,5.1-11.82.57-16.37s-11.47-4.42-16.64.71q-15.9,15.81-31.74,31.73c-5.1,5.1-10.18,10.23-15.8,15.88Z",
    transform: "translate(-6091.57 -1137.12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAddAmountIcon);
export default __webpack_public_path__ + "static/media/total_add_amount_icon.6ac87c9e4d0ca7e0ab9bcc048b313366.svg";
export { ForwardRef as ReactComponent };